import * as Types from './types'

export default {
  SET_BRANDS: async ({ commit }, payload) => {
    commit(Types.SET_BRANDS, payload)
  },
  SET_SELECTED_BRAND: async ({ commit }, payload) => {
    commit(Types.SET_SELECTED_BRAND, payload)
  },
  SET_BRAND_FIN_YEAR : async ({ commit }, payload) => {
    commit(Types.SET_BRAND_FIN_YEAR, payload)
  },
  SET_ADMIN_EMAIL: async ({ commit }, payload) => {
    commit(Types.SET_ADMIN_EMAIL, payload)
  },
  SET_FIN_YEAR : async ({ commit }, payload) => {
    commit(Types.SET_FIN_YEAR, payload)
  },
  SET_ROLE_AND_PERMISSIONS : async ({ commit }, payload) => {
    commit(Types.SET_ROLE_AND_PERMISSIONS, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/global/actions.js